<template>
  <div>
    <div class="mx-auto" style="max-width: 800px;">
      <router-link
        :to="`/dash`"
      >
        <b-button
          class="bg-transparent border-0 text-gray-500 font-weight-bold d-flex align-items-center"
          variant="light"
        >
          <b-icon-chevron-left font-scale="0.8" class="mr-1" /> Back
        </b-button>
      </router-link>
      <b-alert :show="invalid" variant="warning" class="text-xs mb-4">
           {{ processingError }}
      </b-alert>
      <SearchResults
        :items="summaryNumber.items"
        @change-flag="(idx, value, component) => { changeFlag(idx, value, component) }"
        @update-item="(idx, value, component) => { updateItem() }"
        @error-item="(idx, value, component) => { errorMessage(idx) }"
      ></SearchResults>
    </div>
  </div>
</template>

<script>
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import { updateFlag } from '../api/shipment';
import SearchResults from './SearchResults.vue';

export default {
  name: 'DashboardShipments',
  props: ['summaryNumbers'],
  data() {
    return {
      invalid: false,
      processingError: '',
    };
  },
  methods: {
    updateItem() {
      // this.$router.go(0);
      this.$emit('getData');
    },
    resetError() {
      this.invalid = false;
    },
    errorMessage(error) {
      this.processingError = error;
      this.invalid = true;
      setTimeout(() => this.resetError(), 4000);
    },
    changeFlag(idx, value, component) {
      const data = {
        data: {
          type: component,
          flag: value,
          id: this.summaryNumber.items[idx].id,
          bookingId: this.summaryNumber.items[idx].booking,
        },
      };
      updateFlag(data).then((res) => {
        console.log(res);
        this.summaryNumber.items[idx].flag = value;
        // this.$router.go(0);
        this.$emit('getData');
      }).catch((err) => {
        this.processingError = err.response.data.error;
      });
    },
  },
  computed: {
    summaryNumber() {
      switch (this.$route.path.split('/').pop()) {
        case 'delivered':
          return this.summaryNumbers.delivered;
        case 'delivering':
          return this.summaryNumbers.delivering;
        case 'toload':
          return this.summaryNumbers.toLoad;
        case 'tooffload':
          return this.summaryNumbers.toOffload;
        case 'pickups':
          return this.summaryNumbers.pickups;
        case 'unpaid':
          return this.summaryNumbers.unpaid;
        case 'delayed':
          return this.summaryNumbers.delayed;
        default:
          console.error('Invalid route');
      }
      return null;
    },
  },
  mounted() {
  },
  components: { SearchResults },
};
</script>

<style scoped>

</style>
